import { ClientEmailData } from 'hooks/webapi/client/useClientEmailQuery';
import { ClientApplication } from 'hooks/webapi/client/useApplicationQuery';
import { ClientPhoneData } from 'hooks/webapi/client/useClientPhoneQuery';
import { Client } from 'hooks/webapi/client/useClientQuery';
import digestMessage from 'hooks/context/EventCollector/hash';

export interface IIdentifyEvent {
  type: 'identify';
  timestamp: number;
  client?: Client;
  application?: ClientApplication;
  email?: ClientEmailData;
  phone?: ClientPhoneData;
  hasEmail: boolean;
  hasApplication: boolean;
  getHash(): Promise<string>;
}

export default class IdentifyEvent implements IIdentifyEvent {
  readonly type = 'identify' as const;

  readonly timestamp: number;

  readonly client?: Client;

  readonly application?: ClientApplication;

  readonly email?: ClientEmailData;

  readonly phone?: ClientPhoneData;

  constructor({
    client,
    application,
    email,
    phone,
  }: {
    client?: Client;
    application?: ClientApplication;
    email?: ClientEmailData;
    phone?: ClientPhoneData;
  }) {
    this.timestamp = new Date().getTime();
    if (client) {
      this.client = client;
    }
    if (application) {
      this.application = application;
    }
    if (email) {
      this.email = email;
    }
    if (phone) {
      this.phone = phone;
    }
  }

  get hasEmail() {
    if (this.email?.email) {
      return true;
    }
    return false;
  }

  get hasApplication() {
    return !!this.application;
  }

  async getHash() {
    return digestMessage(this.email?.email ?? '');
  }
}
